import { MenuItem } from '@ih/app/client/shared/interfaces';

export class SetMenuItems {
  public static readonly type = '[Menu] SetMenuItems';
  constructor(public readonly menuItems: MenuItem[]) {}
}
